<template>
  <TableLayout>
    <div slot="search-form" class="data">
        <div class="item-title">数据看板</div>
        <div class="data-summary">
          <div class="data-item">
            <div>会员数量</div>
            <div class="data-num">{{ countData.users }}</div>
          </div>
          <div class="parting"></div>
          <div class="data-item">
            <div>今日活跃用户</div>
            <div class="data-num">{{ countData.activeUsers }}</div>
          </div>
          <div class="parting"></div>
          <div class="data-item">
            <div>订单总数</div>
            <div class="data-num">{{ countData.orders }}</div>
          </div>
          <div class="parting"></div>
          <div class="data-item">
            <div>订单总金额</div>
            <div class="data-num">{{ countData.money }}</div>
          </div>
          <div class="parting"></div>
          <div class="data-item">
            <div>本月订单数</div>
            <div class="data-num">{{ countData.mouthOrders }}</div>
          </div>
          <div class="parting"></div>
          <div class="data-item">
            <div>本月订单总金额</div>
            <div class="data-num">{{ countData.mouthMoney }}</div>
          </div>
        </div>
      </div>
    <template v-slot:table-wrap>
      <div class="change-style">
        <div class="item-title">订单金额趋势</div>
        <div style="display: flex;">
          <el-button type="text" @click="changeCount(7)">7日</el-button>
          <div style="margin: 0 5px;">|</div>
          <el-button type="text" @click="changeCount(30)">30日</el-button>
        </div>
      </div>
      <div ref="orderChange" class="bottom">
        
      </div>
    </template>
    
  </TableLayout>
</template>

<script>
import TableLayout from '@/layouts/TableLayout'
import * as echarts from 'echarts';
import { findAllList, createCoffeeTask } from '@/api/business/taskRule'
export default {
  components: {
    TableLayout
  },
  data() {
    return {
      countData: {
        users: 1000,
        activeUsers: 1000,
        mouthOrders: 10,
        mouthMoney: 100000,
        orders: 10,
        money: 100000
      },
      orderCorderCount: [10,10,20,10,40,10,30],
      opinionData: ['3.20', '3.21', '3.22', '3.23', '3.24', '3.25', '3.26'],
      myChart: null
    }
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.orderChange)
    window.addEventListener('resize', () => {
      this.myChart.resize()
    })
    this.renderOrderChange()
    findAllList({})

  },
  methods: {
    renderOrderChange() {
      this.myChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.opinionData
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: '订单',
          type: 'line',
          stack: '总量',
          data: this.orderCorderCount
        }]
      })
      
    },
    changeCount(page) {
      if (page == 7) {
        this.orderCorderCount = [10,10,20,10,40,10,30]
        this.opinionData = ['3.20', '3.21', '3.22', '3.23', '3.24', '3.25', '3.26']
      } else {
        this.orderCorderCount = [11,10,20,10,40,10,30,20,10,20,10,40,10,30,10,10,20,10,40,10,30,10,10,20,10,40,10,30,20,40]
        this.opinionData = ['3.01','3.02','3.03','3.04','3.05','3.06','3.07','3.08','3.09','3.10','3.11','3.12','3.13','3.14','3.15','3.16','3.17','3.18','3.19','3.20', '3.21', '3.22', '3.23', '3.24', '3.25', '3.26', '3.27','3.28','3.28','3.30',]
      }
      // this.orderCorderCount.push(1)
      // this.opinionData.push(1)
      this.renderOrderChange()

    }
  },
}
</script>

<style lang="scss" scoped>
.data {
  padding-bottom: 10px;
}
.item-title {
  font-weight: 500;
  
}
.data-summary {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  .data-item {
    flex: 1;
    height: 80px;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1) ;
    box-sizing: border-box;
    padding: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .data-num {
      font-size: 20px;
      font-weight: 700;
      color:aqua
    }
  }
  .parting {
    width: 20px;
  }
}
.change-style {
  display: flex;
  justify-content: space-between;
  line-height: 31px;
}
.bottom {
  height: 500px;
}
</style>

